var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('span',[_vm._v("Campaign will be appear if browser language is "+_vm._s(_vm.data.map(function (d) { return _vm.langs[d].join(" / "); }).join(" or ")))])])}
var staticRenderFns = []

export { render, staticRenderFns }